import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";

export default function CustomersHighlight(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const partnersList = [
    { name: "Development Partners", initials: "DPs" },
    { name: "Donor Community", initials: "DC" },
    { name: "Local Government Authorities ", initials: "LGAs" },
    { name: "Foundation for Civil Society ", initials: "FCS" },
    { name: "Non Governmental Organizations", initials: "NGOs" },
    { name: "Community Based Organizations", initials: "CBOs" },
    { name: "Faith Based Organizations", initials: "FBOs" },
    { name: "Community Members", initials: "CM" },

  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <div
      className="MainBodySection bg-surface"
      style={{ paddingTop: "50px" }}
    >
      <div className="container pb-5">
        <div className="row pb-5">
          <div className="col-md-12 mb-3">
						<h3
							className="main-section-title"
						>
							OUR PARTNERS
						</h3>
          </div>

          <div className="col-md-12">
            <div className="partners-slider-wrapper position-relative overflow-hidden">
              <div className="partners-slider d-flex align-items-center">
                {[...partnersList, ...partnersList].map((partner, i) => (
                  <div
                    key={i}
                    className="partner-card text-center mx-3 flex-shrink-0"
                    style={{ 
											width: "240px",
										}}
                  >
                    <div
                      className="partner-logo d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
                      style={{
                        width: "80px",
                        height: "80px",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        background: `linear-gradient(135deg, hsl(${(i * 40) % 360}, 70%, 50%), hsl(${(i * 40 + 60) % 360}, 70%, 60%))`,
                      }}
                    >
                      {partner.initials}
                    </div>
                    <div className="fw-medium font-bold">
											<h6
												style={{
													whiteSpace: "normal",
													wordBreak: "break-word",
													lineHeight: "1.3",
												}}
											>
												{partner.name}
											</h6>
										</div>
                    <div className="text-muted small">{partner.country}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes slideLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .partners-slider {
          animation: slideLeft 10s linear infinite;
          width: max-content;
        }

        .partners-slider-wrapper {
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .partners-slider { animation-duration: 20s; }
        }

        @media (prefers-reduced-motion: reduce) {
          .partners-slider { animation: none; }
        }
      `}</style>
    </div>
  );
}
